import type { RefObject, FC } from 'react';
import { useRef } from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { ThemeSurface } from '@wix/da-react-context/pkg/ThemeContext';
import Surface from '@wix/da-ds/pkg/Surface';
import SelectableDeviationListItem from './SelectableDeviationListItem';
import { useCenterOnSelectionModeToggle } from '../../hooks/useCenterOnSelectionModeToggle';

import s from './SelectableDeviationList.scss';

interface Props {
  deviations: PapiDeviation[];
  selected: number[];
  hasSelection: boolean;
  scrollableRef: RefObject<HTMLElement | null>;
  onSelect: (idx: number, isSelected: boolean) => void;
}

const SelectableDeviationList: FC<Props> = ({
  deviations,
  selected,
  hasSelection,
  scrollableRef,
  onSelect,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  useCenterOnSelectionModeToggle(
    scrollableRef,
    containerRef,
    selected,
    hasSelection
  );

  return (
    <Surface className={s['list-wrapper']} type={ThemeSurface.SECONDARY}>
      <BiLoggerContextProvider value={{ sectionname: 'studio-mobile-list' }}>
        <div className={s['list']} ref={containerRef}>
          {deviations.map((deviation, idx) => (
            <SelectableDeviationListItem
              key={`item-${deviation.deviationId}`}
              className={s['item']}
              deviation={deviation}
              offset={idx}
              scrollToRef={containerRef}
              isSelected={selected.includes(idx)}
              onChange={checked => onSelect(idx, checked)}
              isInSelectMode={hasSelection}
            />
          ))}
        </div>
      </BiLoggerContextProvider>
    </Surface>
  );
};
SelectableDeviationList.displayName = 'SelectableDeviationList';

export default SelectableDeviationList;
